<!-- ZoomLinksBox.vue -->
<template>
  <div class="box-container">
    <h2 class="box-title">
      <slot name="title"></slot>
    </h2>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

  <script>
export default {
  name: "BoxWithShadow",
};
</script>

  <style scoped>
.box-container {
  background-color: white;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 16px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.box-title {
  font-weight: 700;
  color: #333;
}
</style>